import { z } from "zod";

export const ValidationErrorResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    errors: z.object({
        name: z.array(z.string()),
    })
});

export type ValidationErrorResponseData = z.infer<typeof ValidationErrorResponse>;